import { render, staticRenderFns } from "./OrderLazadaData.vue?vue&type=template&id=0dee5452&scoped=true"
import script from "./OrderLazadaData.vue?vue&type=script&lang=js"
export * from "./OrderLazadaData.vue?vue&type=script&lang=js"
import style0 from "./OrderLazadaData.vue?vue&type=style&index=0&id=0dee5452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee5452",
  null
  
)

export default component.exports